import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rt-redactor-inserts-dropdown-header',
  templateUrl: 'redactor-inserts-dropdown-header.component.html',
  styleUrls: ['./redactor-inserts-dropdown-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedactorInsertsDropdownHeaderComponent {
  @Input() public label: string;
  @Input() public hasBackAction: boolean = true;
  @Input() public searchQuery: string;
  @Input() public hasSearch: boolean = false;
  @Input() public hasSettings: boolean = false;
  @Input() public searchPlaceholder: string;

  @Output() public goBack: EventEmitter<MouseEvent> = new EventEmitter();
  @Output() public goToSettings: EventEmitter<MouseEvent> = new EventEmitter();
  @Output() public searchQueryChange: EventEmitter<string> = new EventEmitter();
  @Output() public closeDropdown: EventEmitter<void> = new EventEmitter();
  @Output() public focusChanges: EventEmitter<boolean> = new EventEmitter();

  public onFocusChanges(value: boolean): void {
    this.focusChanges.emit(value);
  }
}
